import { render } from "./Message.vue?vue&type=template&id=ffbc7c30&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=ffbc7c30&scoped=true&lang=css"

import exportComponent from "/Users/jean-yvesfournet/Documents/projects/javascript/vue/shop-flash/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffbc7c30"]])

export default __exports__